var map = {
	"./afl.svg": 77367,
	"./aleague.svg": 64330,
	"./chest.svg": 691,
	"./epl.svg": 8453,
	"./nba.svg": 88485,
	"./nfl.svg": 59332,
	"./nrl.svg": 54512,
	"./odi.svg": 88870,
	"./t20.svg": 74166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 12054;